import React, { useState, useEffect } from 'react';

const AdminSiteSettings = () => {
    const [settings, setSettings] = useState({
        companyName: 'VishwaVoyagerz Tours and Travel',
        address: 'Bhoomi Mall, 318, plot 8, Sector 15, CBD Belapur, Belapur, Maharashtra 400614',
        phone: '+91 9762902455',
        email: 'info@vishwavoyagerz.com',
        facebookUrl: 'https://www.facebook.com/share/1ArjypHZtG/',
        instagramUrl: 'https://www.instagram.com/_vishwa_voyagerz_?igsh=MWxoNnM1ZzlqNnd4aA=='
    });
    const [loading, setLoading] = useState(true);
    const [saving, setSaving] = useState(false);

    const API_URL = (process.env.REACT_APP_API_URL || 'http://127.0.0.1:3001').replace(/\/$/, '');

    const getAuthHeaders = React.useCallback(() => {
        const token = localStorage.getItem('adminToken');
        return {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
        };
    }, []);

    const loadSettings = React.useCallback(async () => {
        try {
            const response = await fetch(`${API_URL}/api/site-settings`, {
                headers: getAuthHeaders()
            });
            const data = await response.json();
            setSettings(data);
        } catch (error) {
            console.error('Error loading settings:', error);
        } finally {
            setLoading(false);
        }
    }, [API_URL, getAuthHeaders]);

    useEffect(() => {
        loadSettings();
    }, [loadSettings]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setSettings(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setSaving(true);
        try {
            const response = await fetch(`${API_URL}/api/site-settings`, {
                method: 'PUT',
                headers: getAuthHeaders(),
                body: JSON.stringify(settings)
            });

            if (response.ok) {
                alert('Site settings updated successfully!');
            } else {
                alert('Failed to update settings');
            }
        } catch (error) {
            console.error('Error saving settings:', error);
            alert('Error saving settings');
        } finally {
            setSaving(false);
        }
    };

    if (loading) return <div className="text-center py-8">Loading...</div>;

    return (
        <div>
            <h2 className="text-3xl font-bold mb-6">Site Settings</h2>
            <div className="bg-white rounded-lg shadow p-6">
                <form onSubmit={handleSubmit}>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
                        <div className="col-span-2">
                            <h3 className="text-xl font-semibold mb-4 border-b pb-2">General Information</h3>
                        </div>
                        <div>
                            <label className="block text-gray-700 font-semibold mb-2">Company Name</label>
                            <input
                                type="text"
                                name="companyName"
                                value={settings.companyName}
                                onChange={handleChange}
                                className="w-full px-4 py-2 border rounded-lg"
                                required
                            />
                        </div>
                        <div>
                            <label className="block text-gray-700 font-semibold mb-2">Contact Email</label>
                            <input
                                type="email"
                                name="email"
                                value={settings.email}
                                onChange={handleChange}
                                className="w-full px-4 py-2 border rounded-lg"
                                required
                            />
                        </div>
                        <div>
                            <label className="block text-gray-700 font-semibold mb-2">Phone Number</label>
                            <input
                                type="text"
                                name="phone"
                                value={settings.phone}
                                onChange={handleChange}
                                className="w-full px-4 py-2 border rounded-lg"
                                required
                            />
                        </div>
                        <div className="col-span-2">
                            <label className="block text-gray-700 font-semibold mb-2">Address</label>
                            <textarea
                                name="address"
                                value={settings.address}
                                onChange={handleChange}
                                rows="3"
                                className="w-full px-4 py-2 border rounded-lg"
                                required
                            ></textarea>
                        </div>
                    </div>

                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
                        <div className="col-span-2">
                            <h3 className="text-xl font-semibold mb-4 border-b pb-2">Social Media Links</h3>
                        </div>
                        <div>
                            <label className="block text-gray-700 font-semibold mb-2">Facebook URL</label>
                            <input
                                type="url"
                                name="facebookUrl"
                                value={settings.facebookUrl}
                                onChange={handleChange}
                                className="w-full px-4 py-2 border rounded-lg"
                                placeholder="https://facebook.com/..."
                            />
                        </div>
                        <div>
                            <label className="block text-gray-700 font-semibold mb-2">Instagram URL</label>
                            <input
                                type="url"
                                name="instagramUrl"
                                value={settings.instagramUrl}
                                onChange={handleChange}
                                className="w-full px-4 py-2 border rounded-lg"
                                placeholder="https://instagram.com/..."
                            />
                        </div>
                    </div>

                    <div className="flex justify-end pt-4 border-t">
                        <button
                            type="submit"
                            disabled={saving}
                            className={`px-6 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 flex items-center ${saving ? 'opacity-70 cursor-not-allowed' : ''}`}
                        >
                            {saving ? (
                                <>
                                    <i className="fas fa-spinner fa-spin mr-2"></i>Saving...
                                </>
                            ) : (
                                <>
                                    <i className="fas fa-save mr-2"></i>Save Settings
                                </>
                            )}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default AdminSiteSettings;
